import * as THREE from 'three';
import { Mesh, Group } from 'three';
import colors from '@/styles/color.scss';
// import { CSG } from 'three-csg-ts';
const ParkingType = {
    lotParking: {
        // 停车场
        color: colors.parkingRoi3dLot,
        nomalOpacity: 0.15,
        activeOpacuty: 0.5,
    },
    idleParking: {
        // 空闲
        color: colors.parkingRoi3dIdle,
        nomalOpacity: 0.4,
        activeOpacuty: 0.6,
    },
    employParking: {
        // 占用
        color: colors.parkingRoi3dEmploy,
        nomalOpacity: 0.4,
        activeOpacuty: 0.6,
    },
    unknownParking: {
        color: colors.parkingRoi3dUnknown,
        nomalOpacity: 0.9,
        activeOpacuty: 0.9,
        lineType: 'dash',
    },
};
const DEGAULT_HEIGHT = 1;
class Parking3D extends Group {
    props;
    normalVector;
    meshs = [];
    resultBSP; // 合并多个mesh
    theme;
    circlePoints;
    hover = false;
    group = new THREE.Group();
    constructor(data) {
        super();
        this.name = this.uuid;
        const { points, theme = 'lotParking' } = data.renderProps;
        this.theme = theme;
        const vectorList = points.map((item) => {
            return new THREE.Vector3(item[0], item[1], item[2]);
        });
        let index = 2;
        for (let i = index; i < points.length; i++) {
            const a = new THREE.Vector3().subVectors(vectorList[0], vectorList[1]);
            const b = new THREE.Vector3().subVectors(vectorList[1], vectorList[index]);
            if (a.normalize().equals(b.normalize()) || a.normalize().equals(b.normalize().negate())) {
                index++;
            }
            else {
                break;
            }
        }
        const plane = new THREE.Plane().setFromCoplanarPoints(vectorList[0], vectorList[1], vectorList[index]); // 三维空间中的二维平面
        this.normalVector = plane.normalize().normal.clone(); // 平面法向量
        vectorList.map((item) => {
            // 将其他点投影到该平面
            return plane.projectPoint(item, new THREE.Vector3());
        });
        /**
         * 将平面上的点更新到point
         */
        data.renderProps.points = vectorList.map((item) => {
            return [item.x, item.y, item.z];
        });
        this.circlePoints = [...data.renderProps.points, data.renderProps.points[0]];
        this.props = data;
        if (theme === 'unknownParking') {
            this.addUnknownRoi();
        }
        else {
            this.addBottomRoi(data);
            this.addVerticalRoi();
        }
    }
    update(data) {
        // const { theme = 'lotParking' } = data.renderProps;
        // this.theme = theme;
        // if (this.theme === 'unknownParking') {
        //   this.addUnknownRoi();
        // } else {
        //   this.addBottomRoi(data);
        //   this.addVerticalRoi();
        // }
        // // this.meshs.push(curMesh);
        // this.add(curMesh);
        // const subRes = CSG.union(curMesh, curMesh);
        // for (let i = 0; i < this.meshs.length; i++) {
        //   this.resultBSP = CSG.union(this.resultBSP, this.meshs[i]);
        // }
        // this.resultBSP = CSG.union(this.meshs[0], this.meshs[1]);
        // const mesh = this.resultBSP.toMesh();
        // this.add(mesh);
        // this.group.name = 'parking';
        // this.add(this.group);
    }
    addBottomRoi(data) {
        const { color, nomalOpacity, activeOpacuty } = ParkingType[this.theme];
        const { points } = data.renderProps;
        const getGroupArr = this.getGroupArr(points);
        const geometry = new THREE.BufferGeometry();
        const vertices = new Float32Array(getGroupArr);
        // 创建属性缓冲区对象
        const attribue = new THREE.BufferAttribute(vertices, 3); // 3个为一组
        // 设置几何体attributes属性的位置position属性
        geometry.attributes.position = attribue;
        const opacity = this.hover ? activeOpacuty : nomalOpacity;
        // 材质对象
        const material = new THREE.MeshBasicMaterial({
            color: new THREE.Color(color).convertSRGBToLinear(),
            side: THREE.DoubleSide,
            transparent: true,
            depthTest: true,
            opacity,
        });
        const curMesh = new THREE.Mesh(geometry, material);
        curMesh.name = curMesh.uuid;
        curMesh.isObserver = true;
        curMesh.onMouseEnter = () => {
            material.opacity = activeOpacuty;
            this.onMouseEnter();
        };
        curMesh.onMouseLeave = () => {
            material.opacity = nomalOpacity;
            this.onMouseLeave();
        };
        this.add(curMesh);
    }
    addVerticalRoi() {
        const { color } = ParkingType[this.theme];
        const urlName = this.theme === 'lotParking' ? 'parking-lot' : 'parking-position';
        const textUrl = require(`@blade-sxp/map/src/assets/${urlName}.png`);
        const points = this.circlePoints;
        const pointDistance = [];
        const distance = points.reduce((totalDistance, point, index) => {
            let segmentDistance = 0;
            if (index > 0) {
                const lastPoint = new THREE.Vector3(...points[index - 1]);
                const currPoint = new THREE.Vector3(...point);
                segmentDistance = lastPoint.distanceTo(currPoint);
            }
            totalDistance += segmentDistance;
            pointDistance.push(totalDistance);
            return totalDistance;
        }, 0);
        // 几何体
        const geometry = new THREE.BufferGeometry(); // 缓冲几何体
        const posArr = [];
        const uvArr = [];
        // 遍历坐标
        points.forEach((point, index) => {
            if (index === 0)
                return;
            const lastPoint = points[index - 1];
            // 三角面1
            posArr.push(...lastPoint);
            uvArr.push(pointDistance[index - 1] / distance, 0);
            posArr.push(...point);
            uvArr.push(pointDistance[index] / distance, 0);
            posArr.push(lastPoint[0], lastPoint[1] + DEGAULT_HEIGHT, lastPoint[2]);
            uvArr.push(pointDistance[index - 1] / distance, 1);
            // 三角面2
            posArr.push(...point);
            uvArr.push(pointDistance[index] / distance, 0);
            posArr.push(point[0], point[1] + DEGAULT_HEIGHT, point[2]);
            uvArr.push(pointDistance[index] / distance, 1);
            posArr.push(lastPoint[0], lastPoint[1] + DEGAULT_HEIGHT, lastPoint[2]);
            uvArr.push(pointDistance[index - 1] / distance, 1);
        });
        geometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(posArr), 3));
        geometry.setAttribute('uv', new THREE.BufferAttribute(new Float32Array(uvArr), 2));
        // 纹理
        const texture = new THREE.TextureLoader().load(textUrl);
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        // 材质
        const material = new THREE.MeshBasicMaterial({
            color: new THREE.Color(color).convertSRGBToLinear(),
            map: texture,
            transparent: true,
            opacity: 1,
            depthWrite: false,
            side: THREE.DoubleSide,
        });
        // 创建围栏
        const mesh = new THREE.Mesh(geometry, material);
        mesh.name = mesh.uuid;
        mesh.isObserver = true;
        mesh.onMouseEnter = () => {
            this.onMouseEnter();
        };
        mesh.onMouseLeave = () => {
            this.onMouseLeave();
        };
        this.add(mesh);
        // this.group.add(mesh);
    }
    addUnknownRoi() {
        const { color } = ParkingType[this.theme];
        const geometry = new THREE.BufferGeometry();
        const gapSize = this.hover ? 0 : 1;
        const material = new THREE.LineDashedMaterial({ color, dashSize: 1, gapSize });
        const points = this.circlePoints;
        const vectorList = points.map((item) => {
            return new THREE.Vector3(item[0], item[1], item[2]);
        });
        geometry.setFromPoints(vectorList);
        const line = new THREE.Line(geometry, material);
        line.name = this.uuid;
        line.isObserver = true;
        line.onMouseEnter = () => {
            material.gapSize = 0;
            this.onMouseEnter();
        };
        line.onMouseLeave = () => {
            material.gapSize = 1;
            this.onMouseLeave();
        };
        line.computeLineDistances();
        this.add(line);
    }
    getGroupArr(points) {
        const sortArr = [0, 1, 2, 2, 3, 0]; // 暂时处理只有四个点的情况
        let groupArr = [];
        for (let i = 0; i < sortArr.length; i++) {
            groupArr = groupArr.concat(points[sortArr[i]]);
        }
        return groupArr;
    }
    dispose() {
        this.traverse(function (obj) {
            if (obj instanceof Mesh) {
                obj.geometry.dispose();
                obj.material.dispose();
            }
            else {
                if (obj.parent) {
                    obj?.parent.remove(obj);
                }
                obj.clear();
            }
        });
        this.parent?.remove(this);
        this.clear();
    }
    onMouseEnter() {
        document.body.style.cursor = 'pointer';
        this.hover = true;
        if (this.props.onMouseEnter && typeof this.props.onMouseEnter === 'function') {
            this.props.onMouseEnter(this);
        }
    }
    onMouseLeave() {
        document.body.style.cursor = '';
        this.hover = false;
        if (this.props.onMouseLeave && typeof this.props.onMouseLeave === 'function') {
            this.props.onMouseLeave(this);
        }
    }
}
export default Parking3D;
